const jp = {
  common: {
    popup: {
      titleConfirm: '保存してもよろしいですか？',
    },
    message: {
      success: '成功しました！',
      assignDepartmentSuccess: '部門への割り当てに成功しました。',
    },
    error: {
      required: 'これは必須項目です!',
      incorrectEmail: 'メールの形式が正しくありません！',
      passwordConfirm: '両方のパスワードは一致する必要があります。',
      minValue: '少なくとも 1 でなければなりません。',
      maxValuePassword: '8文字以上である必要があります',
    },
    apiErrorMessages: {
      //- Common error message for each error code.
      errorCodeUnknown: '失敗しました',
      errorCode1003a:
        '1回のリクエストでアップロードできるドキュメントは最大{{remainPageCount}}ページまでです。',
      errorCode1003b:
        'ご契約のサービスプランで許可されているページ数の上限に達しました。サービスを継続して利用するには、管理者にお問い合わせください。',
      errorCode3000: 'メールアドレスはシステムに既に存在します。',
      errorCode3002: 'このユーザーを削除できません',
      errorCode7001: 'Primary column cannot be deleted.',
    },
  },
  menuBar: {
    documentTemplate: 'ドキュメント テンプレート',
    user: {
      uploadDocument: 'ドキュメントをアップロード',
      allDocument: 'マイ ドキュメント',
      workFlow: 'ワークフロー',
      workFlowRequest: 'リクエストワークフロー',
      workFlows: 'ワークフロー一覧',
      serviceHistory: 'サービス履歴',
      support: 'サポート',
    },
    admin: {
      billing: '請求',
      invoice: '請求書',
      usage: '使用状況',
      orgStructure: '部門とユーザー',
      departments: '部門',
      users: 'ユーザー',
      configuration: '構成',
      logging: '監査ログ',
      MBAL: 'MBAL',
      docsetMap: 'ドキュメントセットマップ',
      templateMap: 'テンプレートマップ',
    },
  },
  header: {
    titleAccount: 'アカウント',
    titleLogOut: 'ログアウト',
    en: 'English (EN)',
    jp: 'Japanese (JP)',
    usage: {
      pageUsed: 'ページ使用済み',
      thisMonth: '今月',
    },
  },
  loginScreen: {
    title: 'ログイン',
    forgotPassword: 'パスワードを忘れた場合?',
    rememberMe: 'ログイン情報を記憶',
    loginUserNotFound: 'ユーザーが見つかりません',
    txtEmail: 'メールアドレス',
    txtPassword: 'パスワード',
    btnSignIn: 'サインイン',
    btnSignInWithMicrosoft: 'Microsoftでサインイン',
    error: {
      loginFail: 'メールアドレスまたはパスワードが間違っています。',
      passwordCurrent: '現在のパスワードが正しくありません。',
      accountDeactivated:
        'アカウントは無効になっています。管理者に問い合わせてサポートを受けてください。',
    },
  },
  Placeholder: {
    email: 'メールアドレス',
    password: 'パスワード',
    forgotpass: 'メールアドレスを入力してください',
    placeholderPassword: 'パスワード',
    inputConfirmPass: '新しいパスワードを確認',
    inputNewPass: '新しいパスワードを入力してください',
    inputCurrentPass: '古いパスワードを入力してください',
  },
  btnYes: 'はい',
  btnNo: 'いいえ',
  btnSend: '送信',
  btnSave: '保存',
  btnCancel: 'キャンセル',
  btnApply: '適用する',
  btnExport: 'エクスポート',
  btnReset: 'リセット',
  btnBack: '戻る',
  btnClose: '閉じる',
  btnDownload: 'ダウンロード',
  btnReview: 'レビュー',
  btnSubmit: '送信',
  btnView: '表示',
  btnDelete: '削除',
  btnDeactivate: '無効化',
  btnActive: 'アクティブ',
  btnEdit: '編集',
  btnConfirm: '確認',
  btnBacksignIn: 'サインインに戻る',
  btnGenerateExcel: 'IDP一覧作成<br>（Excelシート作成） ',
  btnClickUpload: 'アップロード',
  txtFormatPassword:
    '英数字以外の記号、半角英小文字大文字数字をそれぞれ1種類以上含む8文字以上で入力してください',
  txtCompanyInfo: '一般情報',
  txtBillinginformation: 'ブロック管理（ユーザー請求）',
  txtDescription: '記述',
  txtUpdateSettingSuccess: 'Update setting success',
  txtUpdateSettingFail: 'Update setting fail',
  txtBillDate: '請求日',
  txtLastPaymentDate: '最終支払日',
  txtClearFilter: 'クリアフィルター',
  txtPagesPerBlock: 'ブロックあたりのページ数',
  txtUpdateDate: 'アップロード日',
  txtUploadDate: '更新日',
  txtConfirm: '確認',
  txtSearch: '検索',
  txtCategory: 'カテゴリー',
  txtOwner: 'タイプ',
  txtPerPage: 'ページ',
  txtDeleteTenant: 'テナントを削除してもよろしいですか?',
  txtTitle: 'タイトル',
  txtRequestName: 'リクエスト名',
  placeholderRequestName: 'リクエストタイトルを入力してください',
  txtName: '名前',
  txtRequireUppercase: ' 大文字 (A ～ Z)',
  txtRequireLowercase: ' 小文字 (a ～ z)',
  txtRequireSpecialCharacter: ' 特殊文字 (!@#$%^&*)',
  txtRequireNumber: ' 数字 (0-9)',
  txtHeadingValidate: 'パスワードには以下を含める必要があります',
  txtInputEmailRequired: 'この情報の入力が必要です！',
  txtDelete: 'このアイテムを完全に削除してもよろしいですか?',
  txtWarningDeleteMulti: 'これらの項目をすべて完全に削除してもよろしいですか？',
  txtFotmatPhone: '電話番号を正しく入力してください',
  txtPassword: 'パスワードの形式が正しくありません',
  txtTotalPackageUsed: '使用パッケージ合計',
  txtTotalBlockUsed: '使用されたブロックの合計',
  txtTotalPageUsed: '使用されたページの合計',
  txtTemplateList: 'テンプレート一覧',
  txtDuplicate: '重複',
  txtDetail: '詳細',
  noSpace: 'すべての空白値は許可されません',
  maxChar:
    'ドキュメント テンプレート セット名は 255 文字以内でなければなりません。テキストを短くしてください。',
  requiredFieldNumber: '最大5桁の数字を入力してください。',
  txtCreate: 'これを作成してもよろしいですか?',
  txtTotalTenants: 'テナント数',
  txtFromMonth: '月から',
  txtToMonth: '月まで',
  txtOf: 'の',
  txtItems: '項目',
  txtMyProfile: '私のプロフィール',
  txtAllTenant: 'テナント状況・入力・編集',
  txtEdit: '編集',
  txtAddTenant: 'テナントを追加',
  txtBilling: '請求',
  txtBillingDescription: 'この情報はすべてのテナントに適用されます',
  txtPages: '{{number}} ページ',
  txtPackageRegisteredCurrentMonth: '登録されたパッケージ －現在の月',
  txtPackageRegisteredNextMonth: '登録されたパッケージ －次の月',
  txtBlockRegisteredCurrentMonth: '登録されたブロック －現在の月',
  txtBlockRegisteredNextMonth: '登録されたブロック －次の月',
  txtCurrentValue: '現在の価値',
  txtNextValue: '現在の価値',
  txtNewValue: '新しい価値',
  descriptionCurrentMonth:
    '新しい価値は現在の月に適用されます。 新しい価値が希望の変更を正確に反映していることを確認してください。',
  descriptionNextMonth:
    '新しい価値は次の月以降適用されます。 新しい価値が希望の変更を正確に反映していることを確認してください。',
  txtPackageRegistered: '登録されたパッケージ',
  txtBlockRegistered: '登録したブロック数',
  txtTotalPackageRegistered: '登録されたパッケージの合計',
  txtTotalBlockRegistered: '登録したブロック合計',
  txtCloseToLimit: '制限に近い',
  txtOutOfCredit: 'クレジット切れ',
  txtBlocksPerPackage: 'パッケージあたりのブロック数',
  txtConfirmPackageRegistered: '登録されたパッケージの確認　－現在の月',
  txtConfirmPackageRegisteredNext: '登録されたパッケージの確認　－次の月',
  txtConfirmBlockRegistered: '登録されたブロックの確認　－現在の月',
  txtConfirmBlockRegisteredNext: '登録されたブロックの確認　－次の月',
  txtFailFormat: 'Fail format',
  txtCurrentlyLimit:
    '現在リクエストは制限を超えております。この問題を解決する為には、管理者へご連絡してください。',
  txtNofPage: 'ページ数',
  txtRemainingPageLimit: '残りページ数',
  txtValuePackageRegistered:
    '新しい価値は現在の価値より大きくなければなりません。',
  txtGenerateExcelUsage: '使用状況作成（Excelシート作成） ',
  txtAccessExpired:
    'アクセスの有効期限切れサポートまたは更新のため、管理者にお問い合わせください。',
  accessExpired: 'Access Expired',
  txtManyPage: 'エラー！ページが多すぎます。',
  txtCreateNewRequest: '新しいリクエストを作成',
  txtGoOCRList: 'IDP結果一覧へ',
  txtlimitExceed: 'Error! Limit exceeded, available page limit = ',
  txtWarning: '警告',
  uploadFileMax: '1アップロードあたり最大10ファイルを選択できます。',
  txtSent: '送信済み',
  txtDescriptionTemplate: '読み取り領域指示',
  txtActionTemplate: '編集',
  txtDescriptionToolTip:
    '定義したフィールド名に従ってアップロードされたドキュメントから値を抽出するIDP をガイドする為、ここに指示を入力してください。',
  txtDescriptionToolTip1: '具体的かつ詳細に記載してください。',
  txtForExample: '例えば：',
  txtForExample1: '名前: Customer Name',
  txtForExample2:
    '読み取り領域指示: The mentioned company at the bottom of document.',
  txtDescriptionToolTip3:
    '明確かつ正確な指示により、IDP 結果の精度が向上することに注意してください。',
  // Tenant
  Tenant: {
    searchTenant: '検索',
    labelTenant: 'テナント',
    labelStatus: '状態',
    labelBlockLimit: 'ブロック制限',
    labelMin: '最小',
    labelMax: '最大',
    labelOnboardDate: '登録日付',
    txtSelectDate: '日付を選択する',
    txtDetailTenant: 'テナント詳細',
    deleteSuccess: 'Delete tenant success',
    deleteFail: 'Delete tenant fail',
    activeSuccess: 'Change status success',
    activeFail: 'Change status fail',
    btnAddTenant: 'テナントを追加',
    updateTenantSuccess: 'Update Tenant Success',
    updateTenantFail: 'Update Tenant Fail',
    createTenantSuccess: 'Create Tenant Success',
    createTenantFail: 'Create Tenant Fail',
    labelUserInformation: 'ユーザー情報',
    labelGeneralInformation: '一般情報',
    labelSubscriptionInformation: 'パッケージ管理（ユーザー請求）',
    getTenantSuccess: 'Get Tenant Success',
    getTenantFail: 'Get Tenant Fail',
    txtAction: '入力・編集',
  },
  Template: {
    txtTemplate: 'テンプレート',
    templateName: 'テンプレート名称',
    txtDetailTemplate: '詳細テンプレート',
    category: '部材種類（用途）',
    description: '備考',
    fieldSet: 'テンプレート項目入力',
    standalone: '標準',
    txtCreateTemplate: 'テンプレートの作成',
    txtEditTemplate: 'テンプレートの編集',
    table: '詳細依頼内容',
    create: '作成する',
    createTemplateSuccess: 'Create Template Success',
    createTemplateFail: 'Create Template Fail',
    txtDocuments: 'ドキュメント',
    descriptionFile: '受け付ける形式: PDF / JPEG / JPG / PNG',
    txtBtnUpload: 'アップロード',
    txtAddNewTemplate: '新規テンプレートの追加',
    txtStandalone: '標準',
    txtTable: '詳細依頼内容',
    txtAddRow: '行を追加する',
    txtAddColumn: '列を追加する',
    txtTableName: 'テンプレート名称',
    txtTableDescription: '備考',
    txtAddTable: 'テーブルを追加する',
    txtName: '名前',
    txtDescriptionTemplate: '読み取り領域指示',
    txtActionTemplate: '編集',
    txtDuplicate: '重複',
    txtAssignTemplateToDepartments: 'テンプレートを部門に割り当てる',
    txtTitleStaff: 'スタッフ: ',
    txtTitleExpired: '期限切れ: ',
    error: {
      emptyName: 'テンプレート名は必須です。',
      emptyCategory: 'カテゴリーは必須です。',
      emptyDescription: '説明は必須です。',
      emptyFieldName: 'フィールド名は必須です。',
      emptyFieldDescription: 'フィールドの説明は必須です。',
      emptyTableName: 'テーブル名は必須です。',
      emptyTableDescription: 'テーブルの説明は必須です。',
      emptyTableFieldName: 'テーブルのフィールド名は必須です。',
      emptyTableFieldDescription: 'テーブルのフィールドの説明は必須です。',
      noFieldsOrTables:
        '少なくとも1つのフィールドまたはテーブルを追加してください。',
      noFieldsInTable: '少なくとも1つのフィールドを追加してください。',
    },
  },
  AddTenant: {
    emailAddress: 'メールアドレス',
    placeholderPassword:
      '英数字以外の記号、半角英小文字大文字数字をそれぞれ1種類以上含む8文字以上で入力してください',
    companyName: '会社名',
    placeholderCompanyName: 'テナントの会社名を入力してください',
    placeholderEmailAddress: 'メールアドレスを入力してください',
    tenantDescriptions: '備考欄（テナント情報追記）',
    placeholderTenantDescriptions: '説明を入力してください',
    inputCompanyName: 'テナントの会社名を入力してください',
    inputAddress: '住所を入力',
    contactEmail: '連絡先メールアドレス',
    placeholderContactEmail: '連絡先メールアドレスを入力',
    address: '住所',
    placeholderAddress: '住所を入力',
    contactName: '連絡先',
    placeholderContactName: '連絡先を入力してください',
    phoneNumber: '電話番号',
    placeholderPhoneNumber: '電話番号を入力してください',
    blockLimit: 'ブロック制限',
    placeholderBlockLimit: '例: 10',
    expiredDate: '期限切れ',
    tenantStatus: 'テナント状況',
    inputRequired: 'この情報の入力が必要です！',
  },
  ChangePassWord: {
    currentPassword: '現在のパスワード',
    newPassword: '新しいパスワード',
    confirmPassword: '新しいパスワードを確認',
  },
  MessageError: {
    msgSentRequestFail: '電子メール アドレスがシステムに存在しません!',
    msgSentChangePasswordFail: '現在のパスワードが正しくありません',
    newPasswordSamePassOld:
      '新しいパスワードは古いパスワードと同じであってはなりません',
    passwordSamePassOld: '新しいパスワードが一致しません!',
    passwordNotMatch: '新しいパスワードが一致しません!',
    valiPassword:
      'パスワードは、小文字、大文字、数字、特殊文字を含む少なくとも8文字以上である必要があります！',
    msgUpdateProfileFail: 'Update profile fail',
    txtFail: '処理に失敗しました！',
    passIncorrect: ' ユーザー名またはパスワードが間違っています!',
    emailExistsTenant: 'メール アドレスがシステムにすでに存在します。',
    companyExist: '部門名はすでにシステムに存在します。',
    cannotDeleteDepartment: 'Can not delete this department',
    cannotDeleteUser: 'Can not delete this user',
  },
  MessageSuccess: {
    msgUpdateProfileSuccess: 'プロファイルの更新が成功しました',
    passwordResetSuccess: 'パスワードが正常にリセットされました。',
    confirmPaymentSuccess: '支払い成功の確認',
  },
  Status: {
    Usage: {
      all: 'すべて',
      normal: '適切',
      closeToLimit: '制限に近い',
      fullCapacity: '登録数上限',
    },
    Template: {
      all: 'すべて',
      custom: 'カスタム',
      standard: '標準',
    },
    OCRList: {
      all: 'すべて',
      processing: '処理中',
      completed: '完了',
      failed: '失敗',
    },
    Tenant: {
      all: 'すべて',
      active: '稼働中',
      deactivate: '非稼働',
    },
  },
  metaTitle: {
    login: 'ログイン',
    metadata: 'メタデータ',
    verification: 'アクティベーションコード',
    loginSSO: 'SSOログイン',
    forgotPassword: 'パスワードを忘れました',
    resetPassword: 'パスワードをリセット',
    home: 'ホーム',
    account: 'アカウント',
    processingRequest: 'リクエストを処理中',
    processingList: 'リストを処理中',
    processingReview: 'レビューを処理中',
    departments: '部門',
    departmentAdd: '部門の追加',
    departmentEdit: '部門の編集',
    departmentDetail: '部門の詳細',
    departmentUsageDetail: 'Usage Details',
    users: 'ユーザー',
    userAdd: 'ユーザーの追加',
    userEdit: 'ユーザーの編集',
    userDetail: 'ユーザー詳細',
    usage: '使用状況',
    invoice: '請求書',
    invoiceDetail: '請求書の詳細',
    documentTemplate: 'ドキュメント テンプレート',
    documentTemplateAdd: 'ドキュメント テンプレートの追加',
    documentTemplateEdit: 'ドキュメント テンプレートの編集',
    documentTemplateDetail: 'ドキュメント テンプレートの詳細',
    serviceHistory: 'サービス履歴',
    support: 'サポート',
    page404: 'ページが見つかりません',
    workFlow: 'ワークフロー',
    requestWorkFlow: 'リクエストワークフロー',
    workFlows: 'ワークフロー一覧',
    logging: '監査ログ',
    mbalDocsetMap: 'MBALドキュメントセットマップ',
    mbalTemplateMap: 'MBAL テンプレート マップ',
    confirmCancelJob: 'データのインポート処理を本当にキャンセルしますか？',
    importing: 'データをインポートしています...',
    importingActive: 'データのインポート処理中...',
    importSuccess: 'データのインポートが完了しました',
    importFail: 'データのインポートに失敗しました',
  },
  requestScreen: {
    header: {
      title: 'ドキュメント処理リクエストの作成',
      titleBtnCancel: 'キャンセル',
      titleBtnSubmit: '提出する',
    },
    workflowSet: {
      workFlowTitle: 'ワークフロー',
      titleBtnCancel: 'リセット',
      titleBtnSubmit: '提出する',
      workFlowLabel: 'Work Flow Name',
      workFlowPlaceholder: 'Select Work Flow',
    },
    form: {
      titleLabel: 'タイトル',
      titlePlaceholder: 'タイトルを入力',
      templateLabel: 'テンプレート',
      templatePlaceholder: 'ドキュメントテンプレートを選択',
      saveDocumentSetBtn: 'このドキュメントテンプレートセットを保存する',
      separatorDocument: '別文書',
      ocr: '光学式文字認識',
      workFlow: 'ワークフロー',
      separatorTypeLabel: 'セパレータータイプ',
      separatorValueLabel: 'セパレーター値',
      separatorTitle: 'セパレーター',
      saveDocumentSuccess: 'Document Template set {{name}} saved.',
    },
    selection: {
      searchPlaceholder: '検索',
      addTemplateBtn: 'テンプレートを追加',
      txtCreateTemplate: 'テンプレートの作成',
      templateTabTitle: 'テンプレートを追加',
      documentSetTabTitle: 'ドキュメントテンプレートセット',
    },
    popupSave: {
      title: 'ドキュメント テンプレート セットを保存',
      label: 'ドキュメント テンプレート セット名',
      description: '説明',
      placeholderDescription:
        'ドキュメントテンプレートの説明を入力してください',
      txtCancel: 'キャンセル',
      txtReset: 'リセット',
      txtSubmit: '送信',
      txtSave: '保存',
    },
    error: {
      txtFilesInvalid: '無効な形式の {{fileName}} が検出されました。',
    },
  },
  templateScreen: {
    header: {
      title: 'テンプレートリスト',
      txtBreadcrumbAdd: '追加',
      txtBreadcrumbEdit: '編集',
      txtCreateTemplate: 'テンプレートの作成',
      txtEditTemplate: 'テンプレートの編集',
    },
    tab: {
      template: 'テンプレート',
      documentSet: 'ドキュメント テンプレート セット',
      txtBtnAddTemplate: 'テンプレートを追加',
      txtBtnCreateTemplate: 'テンプレートを作成する',
      txtBtnAssignTo: '割り当て先',
      txtBtnDelete: '削除',
      txtBtnAddDocumentSet: 'テンプレート セットを追加',
      txtBtnSyncTemplate: '同期する',
      txtBtnImportTemplate: 'Import',
      txtBtnExportTemplate: 'Export ({{count}})',
    },
    formSearch: {
      searchLabel: 'テンプレート名で検索',
      categoryLabel: 'カテゴリー',
      createdByLabel: '作成者',
      searchPlaceholder: 'テンプレート名を入力',
      categoryPlaceholder: 'すべて',
      createdByPlaceholder: 'すべて',
      searchTemplateLabel: 'テンプレート名、カテゴリーで検索',
      searchTemplatePlaceholder: 'テンプレート名、カテゴリーを入力',
    },
    detailScreen: {
      header: {
        title: '詳細テンプレート',
        txtBtnEdit: '編集',
      },
      info: {
        title: '一般情報',
        templateName: 'テンプレート名',
        category: 'カテゴリ',
        description: '説明',
      },
      field: {
        title: 'フィールド セット',
        description: 'スタンドアロン',
        fieldName: '名前',
        fieldDescription: '説明',
      },
      table: {
        title: 'テーブル',
        nameCol: '名前',
        descriptionCol: '説明',
      },
    },
    listTemplate: {
      popupDocumentSet: {
        titleCreate: 'ドキュメント テンプレート セットの作成',
        titleEdit: 'ドキュメント テンプレート セットの編集',
        txtAlert:
          'ドキュメント テンプレート セットは、ドキュメントを処理するときにテンプレートをすばやく選択できるようにするために作成されます。',
        delete: {},
        field: {
          name: 'ドキュメントテンプレートセットの名前',
          namePlaceholder:
            'ドキュメントテンプレートセットの名前を入力してください',
          description: '説明',
          descriptionPlaceholder: '説明を入力してください',
          listTemplate: 'どのドキュメントテンプレートがセットに含まれますか？',
          selectTemplatePlaceholder: 'テンプレートを選択してください',
        },
        txtBtnSave: '保存',
        txtBtnCancel: 'キャンセル',
        txtBtnSubmit: '送信',
      },
      tableTemplate: {
        id: 'ID',
        templateName: 'テンプレート名',
        category: 'カテゴリ',
        createdBy: '作成者',
        createdTime: '作成時刻',
        lastUpdated: '最終更新',
        action: 'アクション',
      },
      tableTemplateSet: {
        id: 'ID',
        templateSetName: 'テンプレートセット名',
        description: '説明',
        noOfTemplate: 'テンプレート数',
        createdBy: '作成者',
        createdTime: '作成日時',
        lastUpdated: '最終更新',
        action: '操作',
      },
      actionText: {
        view: '表示',
        assignTo: '割り当て先...',
        edit: '編集',
        share: '共有',
        delete: '削除',
        duplicate: '複製',
      },
    },
    message: {
      create: {
        success: 'ドキュメントテンプレートセットの作成に成功しました',
        error: 'ドキュメントテンプレートセットの作成中にエラーが発生しました',
      },
      edit: {
        success: 'ドキュメントテンプレートセットの編集に成功しました',
        error: 'ドキュメントテンプレートセットの編集中にエラーが発生しました',
      },
      error: {
        templateSelected: '少なくとも1つのテンプレートを追加してください',
      },
    },
    popupConfirm: {
      title: 'このテンプレートの作成をキャンセルしてもよろしいですか?',
    },
    popupDelete: {
      titleDocumentSet:
        'ドキュメントセット {{templateName}} を削除してもよろしいですか？',
      titleTemplate:
        'テンプレート {{templateName}} を削除してもよろしいですか？',
      titleTemplateMultiple:
        '選択したすべてのテンプレートを削除してもよろしいですか？この操作は元に戻すことができません。',
      titleSyncTemplate: '古いデータを同期して上書きしますか？',
    },
    popupSyncTemplate: {
      title: '同期テンプレート',
      system: 'システム',
      templateTobeSync: '同期するテンプレート',
      language: {
        en: '工学',
        jp: '日本',
        vn: 'ベトナム',
      },
      status: {
        new: '新しい',
        updated: 'アップデート',
        notChanged: '変更されていない',
      },
      syncDate: '同期日',
    },
    importTemplate: {
      title: 'Import document templates',
      dropFile: 'Drop a template bundle here or click to browse',
      fileHint: 'JSON template bundle, up to 2 MB and 100 templates',
      invalidFile: 'Please select a JSON template bundle',
      fileTooLarge: 'The template bundle must not exceed 2 MB',
      preview: 'Preview import',
      previewFailed: 'Could not preview the template bundle',
      previewSummary:
        '{{total}} templates: {{newCount}} new, {{conflict}} conflicts, {{unchanged}} unchanged',
      templateName: 'Template name',
      status: 'Status',
      action: 'Import action',
      statusLabel: {
        new: 'New',
        unchanged: 'Unchanged',
        conflict: 'Conflict',
        invalid: 'Invalid',
      },
      actionImport: 'Import',
      actionSkip: 'Skip',
      actionCopy: 'Create copy',
      actionOverwrite: 'Overwrite',
      confirmImport: 'Import templates',
      importFailed: 'Could not import templates',
      importSuccess:
        'Imported {{created}}, updated {{updated}}, copied {{copied}}, skipped {{skipped}} templates',
    },
  },
  processingScreen: {
    header: {
      title: '「文書処理リスト」、',
      txtBtnGenerateExcel: 'Excel の生成',
      txtBtnCreateRequest: 'リクエストの作成',
    },
    status: {
      all: 'すべて',
      sending: '送信中',
      processing: '処理待ち',
      extracting: '抽出中',
      finished: '完了',
      failed: '失敗',
      cancelling: 'Cancelling',
      cancelled: 'Cancelled',
    },
    formSearch: {
      searchLabel: 'リクエスト名で検索',
      searchPlaceholder: 'リクエスト名を入力してください',
      statusLabel: 'ステータス',
      dateRangeLabel: '日付範囲',
      statusPlaceholder: 'すべて',
      txtBtnSearch: '検索',
      txtBtnClear: 'クリア',
    },
    list: {
      status: {
        sending: '送信中',
        processing: '処理待ち',
        extracting: '抽出中',
        finished: '完了',
        failed: '失敗',
        cancelled: 'Cancelled',
        cancelling: 'Cancelling',
      },
      table: {
        id: 'ID',
        requestName: 'リクエスト名',
        templateID: 'テンプレートID / ドキュメントセットID',
        noOfTemplate: 'テンプレート数',
        page: 'ページ',
        updateTime: '更新日時',
        status: 'ステータス',
        action: 'アクション',
        row: {
          templates: '{{numberTemplate}} テンプレート',
        },
        uploadedDocument: 'アップロードされたドキュメント',
        uploadedTime: 'アップロード時間',
        confidenceScoreTitle: '信頼スコア',
      },
      confirmCancel:
        'Are you sure you want to cancel this extraction request? This action cannot be undone.',
      cancelSuccess:
        'Cancellation completed. The request will not be processed.',
    },
    reviewScreen: {
      header: {
        title: 'レビュー: {{name}} (リクエスト: {{requestId}})',
        titleBtn: '保存とエクスポート',
        dropDownBtn: {
          save: 'Save Result',
          export: 'Save & Export to Excel file',
        },
      },
      uploadReview: {
        uploaded: 'アップロード済み',
        upload: 'アップロード',
        readyToReview: 'レビューの準備ができました',
        processing: '処理中',
        failed: '失敗しました',
        documentNotFound: 'ドキュメントが見つかりません',
        loadingData: 'データを読み込んでいます...',
        loadingDocument: 'ドキュメントを読み込んでいます...',
        cancel: 'Cancelling',
      },
      PDFViewer: {},
      ResultViewer: {
        title: 'レビュー',
        nameField: '名前',
        valueField: '値',
        titleHeaderTable: 'フィールド ',
        template: 'Template',
        editTemplate: 'Edit Template',
        titleStand: 'Stand-alone',
        showConfident: '信頼度スコアを表示',
        hideConfident: '信頼スコアを非表示',
        displayOption: '表示オプション',
        lowScore: '信頼度スコアが低い',
        highScore: '高い信頼スコア',
        suggestedData: '提案されたデータ',
        addRowBelow: '下に行を追加',
        deleteRow: '行を削除',
      },
      popupCancelConfirm: {
        title:
          '保存されていない変更は元に戻されますので、本当にキャンセルしますか？',
      },
      popupConfirm: {
        title: '確認する',
        titleBtnCancel: 'キャンセル',
        titleBtnOk: 'わかりました',
      },
      contextMenu: {
        insertRowAbove: '上に行を挿入',
        insertRowBelow: '下に行を挿入',
        duplicateRowAbove: '上に行を複製',
        duplicateRowBelow: '下に行を複製',
        deleteRow: '行を削除',
      },
      toolbarPDF: {
        zoomOut: 'ズームアウト',
        zoomIn: 'ズームイン',
        pageFirst: 'ページ先頭',
        pagePrevious: '前のページ',
        pageNext: '次のページ',
        pageLast: 'ページ最後',
        rotateLeft: '左に回転',
        rotateRight: '右に回転',
      },
    },
  },
  usageScreen: {
    header: {
      title: '使用の詳細',
      txtBtnExportExcel: 'Excel にエクスポート',
    },
    formFiller: {
      searchLabel: '部門名',
      searchPlaceholder: '部門名で検索',
      expiryDateLabel: '有効期限',
      expiryPlaceholder: 'dd/mm/yyyy',
      statusLabel: 'ステータス',
      statusPlaceholder: 'すべて',
      txtBtnSearch: '検索',
      txtBtnClear: 'クリア',
    },
    table: {
      departmentName: '部門名',
      departmentId: '部署ID',
      onboard: 'オンボード',
      month: '月',
      regBlocks: '登録ブロック',
      blockUsed: 'ブロック使用済み',
      pageUse: 'ページ使用',
      noOfRequest: 'リクエスト数',
      status: 'ステータス',
    },
  },
  departmentScreen: {
    header: {
      title: '「部門」',
      titleCreateDepartment: '新しい部門を作成',
      titleEditDepartment: 'ユーザーの編集',
      titleDetail: '部門詳細',
      txtBtnNewDepartment: '新しい部門',
      txtBtnEdit: '編集',
      txtBtnSave: '保存',
      txtBtnCancel: 'キャンセル',
      usageDetai: 'Usage Details',
    },
    formFilter: {
      searchLabel: '部署名',
      searchPlaceholder: '部署名で検索',
      usageDepartmentSearchLabel: 'Department ID',
      usageDepartmentSearchPlaceholder: 'Department ID',
      usageUserSearchLabel: 'User ID',
      usageUserSearchPlaceholder: 'User ID',
      statusLabel: 'ステータス',
      statusPlaceholder: 'すべて',
      expiryDateLabel: '有効期限',
      expiryDatePlaceholder: 'MM/YYYY',
      fromMonthLabel: 'From Month',
      toMonthLabel: 'To Month',
      usageDetailDatePlaceholder: 'MM/YYYY',
      createdDateLabel: '作成日',
      status: {
        all: 'すべて',
        active: '有効',
        deactivate: '無効',
      },
      txtBtnSearch: '検索',
      txtBtnClear: 'クリア',
    },
    table: {
      No: 'No.',
      departmentName: '部署名',
      departmentId: 'Department ID',
      requestId: 'Request ID',
      noOfUsers: 'いいえ。ユーザーの数',
      userId: 'User ID',
      userName: 'Staff Name',
      userEmail: 'User Email',
      pages: 'Pages',
      uploadedTime: 'Uploaded Time',
      blockCurrentMonth: '登録今月のブロック',
      blockNextMonth: '登録来月のブロック',
      createdDate: '作成日',
      expired: '期限切れ',
      activate: '活性化',
      action: 'アクション',
      status: 'status',
      blockLimit: 'Reg. Blocks',
    },
    formDepartment: {
      title: '基本情報',
      departmentNameLabel: '部門名',
      descriptionLabel: '説明',
      departmentNamePlaceholder: '部門名を入力してください',
      descriptionPlaceholder: '部門の説明を入力してください',
      subscriptionDetails: 'サブスクリプション詳細',
      blockLimitLabel: 'Block Limit',
      blockLimitPlaceholder: 'Enter Block Limit',
      currentMonthLabel: '登録ブロック数 - 今月',
      currentMonthPlaceholder: '登録されたブロック数を入力してください',
      nextMonthLabel: '登録ブロック数 - 来月',
      nextMonthPlaceholder: '登録されたブロック数を入力してください',
      expiryDateLabel: '有効期限',
      activateLabel: '有効化',
      templateListTitle: 'テンプレートリスト',
      spanCardContent: '{{language}} - ID: {{id}} - Category: {{category}}',
      spanCardTime: 'Created: {{created}} - Updated: {{updated}}',
      txtAlreadyAdded: '既に追加済み（{number}）',
      txtNotAdded: '未追加（{number}）',
      titleUserList: 'ユーザーリスト',
      titleTemplateList: 'テンプレートリスト',
      titleMetadataList: 'メタデータリスト',
      titleWorkflowList: 'ワークフローリスト',
      formFilter: {
        searchLabelUserList: 'User Name or Email',
        searchPlaceholderUserList: 'Search by user name or email',
        statusLabel: 'Status',
        statusPlaceholder: 'All',
        createdDateLabel: 'Created Date',
        searchLabelTemplateList: 'Search by Template Name',
        searchPlaceHolderTemplateList: 'Enter Template Name',
        categoryLabel: 'Category',
        status: {
          all: 'All',
          active: 'Active',
          deactivate: 'Deactivated',
        },
        txtBtnSearch: 'Search',
        txtBtnClear: 'Clear',
        searchPlaceHolderMetadataList: 'テーブル名を入力してください',
        searchPlaceHolderWorkflowList: 'ワークフロー名を入力してください',
        searchLabelWorkflowList: 'Search by Name or Description',
      },
      table: {
        txtNo: 'No.',
        txtUserName: 'User Name',
        txtUserEmail: 'User Email',
        txtCreateDate: 'Create Date',
        txtStatus: 'Status',
        txtAction: 'Action',
        txtID: 'ID',
        txtTemplateName: 'Template Name',
        txtIndustry: 'Industry',
        txtCategory: 'Category',
        txtLanguage: 'Language',
        txtCreatedTime: 'Created Time',
        txtLastUpdate: 'Last update',
        txtCreatedAt: 'Created At',
        txtUpdatedAt: 'Updated At',
        txtWorkflowName: 'Name',
        txtDescription: 'Description',
      },
      txtBtnAssignTemplate: 'Assign Templates',
      txtWarning:
        'Search templates and select which templates you want to assign to the department.',
      txtBtnAssignWorkflow: 'Assign Workflow',
      txtWarningAssignWorkflow:
        'Search workflows and select which workflows you want to assign to the department.',
      txtBtnAssignTable: 'Assign Metadata',
      txtWarningAssignTable:
        'Search metadatas and select which metadatas you want to assign to the department.',
      txtBlockLimitEditHistory: 'Block Limit Edit History',
    },
    popupDelete: {
      titleDepartment: '部門 {{departmentName}} を削除してもよろしいですか?',
    },
    error: {
      messageDepartmentNameExist: '部門はすでにシステムに存在します。',
      messageBlockLimit:
        'BnK で登録されたブロック制限を超えるブロック数を部門に割り当てることができません。割り当てを調整してください。',
    },
    blockLimitHistory: {
      title: 'Block Limit Edit History',
      modifyTime: 'Modification Time',
      oldBlockLimit: 'Old Block Limit',
      newBlockLimit: 'New Block Limit',
      modifier: 'Modifier',
    },
  },
  userScreen: {
    header: {
      title: 'ユーザー',
      titleCreateUser: 'ユーザーの作成',
      titleEditUser: 'ユーザーの編集',
      txtBtnNewUser: 'ユーザーを追加',
      txtBtnSave: '保存',
      userDetail: 'User Details',
    },
    formFilter: {
      searchLabel: 'ユーザー名またはメールアドレス',
      searchPlaceholder: '名前またはメールアドレスで検索',
      statusLabel: 'ステータス',
      departmentLabel: '部門',
      createdDateLabel: '作成日',
      createdDatePlaceholder: 'dd/mm/yyyy',
      status: {
        all: 'すべて',
        active: 'アクティブ',
        deactivate: '非アクティブ',
      },
      department: {
        all: 'すべて',
      },
      txtBtnSearch: '検索',
      txtBtnClear: 'クリア',
    },
    table: {
      staffName: 'スタッフ名',
      emailAddress: 'メールアドレス',
      department: '部署',
      blockLimit: 'ブロック制限',
      createdDate: '作成日',
      expiryDate: '有効期限',
      activate: '有効化',
      action: 'アクション',
    },
    status: {
      active: '稼働中',
      deactivate: '非稼働',
    },
    formUser: {
      title: '「一般情報」',
      emailLabel: 'メール',
      passwordLabel: 'パスワード',
      staffNameLabel: 'スタッフ名',
      departmentLabel: '部門',
      phoneLabel: '電話番号',
      descriptionLabel: '説明',
      emailPlaceholder: 'ユーザーの電子メールを入力',
      passwordPlaceholder: 'パスワードを入力',
      staffNamePlaceholder: 'スタッフ名を入力してください',
      departmentPlaceholder: '部門を選択',
      phonePlaceholder: '電話番号を入力してください',
      descriptionPlaceholder: '説明を入力',
      subscriptionDetails: 'サブスクリプションの詳細',
      blockLimitLabel: 'ブロック制限',
      expiryDateLabel: '有効期限',
      activateLabel: 'アクティブ化',
      blockLimitPlaceholder: 'ブロック制限を入力',
    },
    popupDelete: {
      titleUser: 'ユーザー {{userName}} を削除してもよろしいですか?',
    },
  },
  activateScreen: {
    title: 'アクティベーションコード',
    email: 'メールアドレス',
    password: 'パスワード',
    confirmPassword: 'パスワードの確認',
    placeHolderEmail: 'メールアドレスを入力',
    placeHolderConfirmPassword: 'パスワードの確認',
    placeHolderPassword: 'パスワードを入力',
    txtBtnCreateAdmin: '管理者アカウントの作成',
    error: {
      message: 'エラー',
      title: 'エラー',
      goHome: 'ホームに戻る',
      passwordNotMatch: 'パスワードが一致しません',
    },
  },
  notFoundScreen: {
    titleNotFound: '申し訳ございませんが、アクセスしたページは存在しません。',
    txtButtonBack: 'ホームに戻る',
  },
  forgotPasswordScreen: {
    title: 'パスワードを忘れた場合',
    btnBack: '戻る',
    forgotPasswordInstructions:
      'すぐに修正いたします。サインアップに使用したメールアドレスを入力してください。パスワードをリセットするためのリンクをお送りします。',
    sendEmail: 'メールを送信',
    resendEmail: 'メールを再送',
    noticeEmailSuccess:
      'メールが送信されました。受信ボックスおよび迷惑メールフォルダを確認してください。',
    error: {
      emailDoesNot: 'メールアドレスが存在していません。',
    },
  },
  resetPasswordScreen: {
    welcomeBack: 'お帰りなさい！',
    resetPasswordInstructions:
      'ログインを続行する前に、新しいパスワードを設定してください。',
    password: 'パスワード',
    confirmPassword: 'パスワードを確認',
    btnResetPassword: 'パスワードをリセット',
    successfully: '成功しました',
    yourPassWordHasBeenChanged: 'パスワードが変更されました',
    signIn: 'サインイン',
    invalidPassword: '無効なパスワード',
    error: {
      password:
        'パスワードは少なくとも8文字、1つの大文字（A-Z）、1つの小文字（a-z）、1つの数字（0-9）、および1つの特殊文字を含む必要があります。',
    },
    success: {
      msgSentRequestSuccess:
        '"メールが送信されました。受信トレイまたは迷惑メールフォルダを確認して、パスワードをリセットしてください。"',
    },
    Placeholder: {
      Password: 'パスワードを入力してください',
      ConfirmPassword: 'パスワードを確認してください',
    },
  },
  processingRequestScreen: {
    headerTitle: 'ドキュメント処理 - AIでファイルを読み取る！',
    headerSubtitle: 'PDFや画像をテキストに変換',
    uploadInstructions:
      'ここにPDFや画像ファイルをクリックまたはドロップしてアップロード',
    btnUpload: 'ファイルを選択',
    acceptedFormats: '対応形式: PDF, JPEG, JPG, PNG',
    fileRestrictions: '最大サイズ: {{maxSize}}MB、最大{{maxFiles}}ファイルまで',
    btnSubmit: '処理する',
    btnDeleteFile: 'すべてのファイルを削除',
    ProgressProcess: 'Processing document...',
    fileProcessingFailed: 'ファイル処理に失敗しました',
    backToUpload: 'アップロードに戻る',
    retryProcessing: '再処理を試みる',
    failedToProcessFileName: 'ファイル {{name}} の処理に失敗しました',
    requestError: {
      unknownError:
        '不明なエラーが発生しました。後でもう一度お試しください。: {{name}}',
      invalidTenantCode:
        'このリクエストにアクセスする権限がありません。: {{name}}',
      overLimitPagePerRequest:
        'リクエストが1回あたりの最大ページ制限を超えています。: {{name}}',
      invalidQuotaCode:
        'クォータが使い果たされました。管理者に連絡してください。: {{name}}',
      tenantExpiredCode:
        'アカウントの有効期限が切れています。管理者に連絡してください。: {{name}}',
      uploadFail:
        'ファイルのアップロードに失敗しました。もう一度お試しください。: {{name}}',
      notFound: 'リクエストされたリソースが見つかりませんでした。: {{name}}',
      InvalidFileType:
        '無効なファイル形式です。有効なファイルをアップロードしてください。: {{name}}',
      tenantInactiveCode:
        'アカウントが無効になっています。管理者に連絡してください。: {{name}}',
      partnerExpiredCode:
        'パートナーアカウントの有効期限が切れています。パートナーに連絡してください。: {{name}}',
      partnerDeactive:
        'パートナーアカウントが無効になっています。パートナーに連絡してください。: {{name}}',
    },
    error: {
      messageFailRequest: 'リクエストの作成に失敗しました',
      messageDepartmentDeactivated:
        '部署が無効化されています。部署に連絡してください。',
      messagePageDetected:
        'アップロードしたドキュメントがページ制限を超えています。最大 30 ページまで許可されます。ページ数を減らしてもう一度お試しください。',
      messageQuotaExceeded:
        '割り当てを超過しました。所属部門に連絡してください',
      messageDepartmentExpired: '部署が期限切れです。部署に連絡してください。',
      messagePartnerDeactivated:
        'パートナーが無効化されています。パートナーに連絡してください。',
    },
  },
  accountScreen: {
    title: 'マイアカウント',
    txtBtnChangePassword: 'パスワードの変更',
    form: {
      title: '一般情報',
      emailLabel: 'メール',
      staffNameLabel: 'スタッフ名',
      phoneLabel: '電話番号',
      departmentLabel: '部署',
      descriptionLabel: '説明',
      subscriptionDetails: 'サブスクリプションの詳細',
      blockLimitLabel: 'ブロック制限',
      expiryDateLabel: '有効期限',
    },
  },
  invoiceScreen: {
    groupInvoice: {
      totalBlockRegistered: '登録されたブロックの合計',
      totalAmount: '合計金額',
      payments: '支払い',
      overdue: '延滞',
      pendingPayments: 'Pending Payments',
      overduePayments: 'Overdue Payments',
    },
    header: {
      title: '請求書',
      titleDetail: '請求書の詳細',
      txtExportPayment: '支払いのエクスポート',
    },
    status: {
      all: 'すべて',
      pending: '保留中',
      paid: '支払い済み',
      overdue: '期限切れ',
    },
    statusDetail: {
      processing: '処理中',
      completed: '完了',
      failed: '失敗',
    },
    formFiller: {
      searchLabel: '部門名で検索',
      searchPlaceholder: '部門名を入力してください',
      monthLabel: '月',
      monthPlaceholder: 'dd/mm/yyyy',
      statusLabel: 'ステータス',
      statusPlaceholder: 'すべて',
      txtBtnSearch: '検索',
      txtBtnClear: 'クリア',
    },
    table: {
      id: 'Invoice ID',
      departmentId: 'Department ID',
      departmentName: 'Department Name',
      tenantID: 'テナントID',
      tenantName: 'テナント名',
      billMonth: '請求月',
      pageUsage: 'ページ使用量',
      blockRegistered: '登録済みブロック',
      totalAmount: '合計金額',
      unitPrice: '単価',
      paymentStatus: '支払い状況',
      paymentDate: '支払い日',
      dueDate: '支払いの期日',
      markAsPaid: '支払い済みにする',
      action: '操作',
    },
    detail: {
      table: {
        id: 'ID',
        nameRequest: 'リクエスト名',
        status: 'ステータス',
        rate: 'レート',
        noOfPage: 'ページ数',
        uploadDate: 'アップロード日',
      },
    },
    error: {
      getInvoiceDetail: 'Get Invoice Detail Fail',
    },
    popupConfirm: {
      txtResetPayment: '支払日をリセットしてもよろしいですか?',
      confirmPayment: '支払いを確認',
      confirmPaymentPlaceholder: 'dd/mm/yyyy',
      paymentDate: '支払い日',
      confirmPaymentSuccess: '支払いの確認に成功しました',
      confirmPaymentFail: '支払いの確認に失敗しました',
    },
    action: {
      view: '表示',
      exportPayment: '支払いをエクスポート',
    },
  },
  workFlowScreen: {
    requestWorkFlow: {
      header: 'すべてのリクエストワークフロー',
      txtBtnCreateWorkflowRequest: 'ワークフローリクエストを作成',
      table: {
        id: '番号',
        name: '名前',
        status: 'ステータス',
        action: 'アクション',
      },
      status: {
        waiting: '待ち中',
        running: '実行中',
        finished: '完了',
        failed: '失敗',
      },
    },
    workflowPopup: {
      create: {
        title: 'ワークフローを作成',
      },
      update: {
        title: 'ワークフローを更新',
      },
    },
    workFlows: {
      header: 'すべてのワークフロー',
      txtBtnCreateWorkflow: 'ワークフローの作成',
      txtBtnExportWorkflow: 'エクスポートのワークフロー',
      table: {
        id: '番号',
        name: '名前',
        description: '説明',
        action: 'アクション',
        updatedAt: 'アップロード日',
        createdBy: '作成者',
      },
      action: {
        edit: '編集',
        duplicate: '複製',
        delete: '削除',
        shareWithAdmin: '共有',
      },
      modalDelete: {
        title: 'Are you sure to delete Flow: {{flowName}}?',
      },
      formFilter: {
        searchLabel: 'Workflow Name',
        searchPlaceholder: 'Search by Workflow name',
      },
      detail: {
        workflowName: 'Workflow Name',
        description: 'Description',
      },
      modalExport: {
        title: 'Export all files',
        subTitle: 'Do you want to retrieve all the local file workflow?',
      },
    },
    editWorkflow: {
      header: {
        title: 'ワークフローの編集',
      },
    },
  },
  metadataScreen: {
    header: 'メタデータテーブル',
    table: {
      id: '番号',
      name: '名前',
      description: '説明',
      action: 'アクション',
    },
    action: {
      edit: '編集',
      delete: '削除',
    },
    addBtn: 'テーブルの作成',
    modalDelete: {
      title: 'テーブルを削除してもよろしいですか: {{tableName}}?',
    },
  },
  loggingScreen: {
    header: '監査ログ',
    table: {
      id: '番号',
      action: 'アクション',
      user: 'ユーザー',
      createdAt: '作成日',
      updatedAt: '更新日',
    },
  },
  mbalScreen: {
    docsetMap: {
      header: 'ドキュメントセットマップ',
      txtBtnCreateDocsetMap: 'ドキュメントセットマップを作成する',
      table: {
        id: '番号',
        documentSet: 'ドキュメントセット',
        claimType: '請求の種類',
        documentType: '文書の種類',
        action: 'アクション',
      },
      popup: {
        titleCreate: 'ドキュメントセットマップの作成',
        titleEdit: 'ドキュメントセットマップの編集',
        titleDelete: 'このアイテムを削除してもよろしいですか?',
      },
    },
    templateMap: {
      header: 'テンプレートマップ',
      txtBtnCreateTemplateMap: 'テンプレートマップの作成',
      table: {
        id: '番号',
        template: 'テンプレート',
        subDocumentType: 'サブドキュメントの種類',
        action: 'アクション',
      },
      popup: {
        titleCreate: 'テンプレートマップの作成',
        titleEdit: 'テンプレートマップの編集',
        titleDelete: 'このアイテムを削除してもよろしいですか?',
      },
    },
  },
};

export default jp;
